//Custom JS
(function ($) {
  "use strict";

  // Update the URL to the server-side script
  const apiUrl = '/wp-admin/admin-ajax.php';
  //console.log(apiUrl);
// Make an asynchronous call to get the nonce
$.ajax({
  type: 'POST',
  url: apiUrl,
  data: {
    action: 'bitcx_aipb_get_nonce', // Use this action to get the nonce
  },
})
.done(async function(nonceResponse) {
  // Parse the JSON response
  const nonceData = JSON.parse(nonceResponse);
  // Use the obtained nonce in subsequent OpenAI API calls
  const nonce = nonceData.nonce;
  
  
  $('#bitcx_aipb_getSolution').on('click', async function () {
    const client_name = $('#bitcx_aipb_client_name').val();
    const freelance_name = $('#bitcx_aipb_freelance_name').val();
    const job_title = $('#bitcx_aipb_job_title').val();
    const problem = $('#bitcx_aipb_problem_desc').val();
    const loadingSpinner = $('#bitcx_aipb_loadingSpinner');
    const ai_response = $('#bitcx_aipb_ai_response');
    
    // Check if any of the fields is empty
    if (client_name.trim() === '') {
      showError('Client Name');
      return;
    }
    
    if (freelance_name.trim() === '') {
      showError('Freelance Name');
      return;
    }
  
    if (job_title.trim() === '') {
      showError('Job Title');
      return;
    }
  
    if (problem.trim() === '') {
      showError('Job Description');
      return;
    }
  
    ai_response.hide();
    try {
      // Show the loading spinner
      loadingSpinner.show();
  
      // Construct the prompt based on the input fields
      const prompt = `Compose a persuasive freelancing proposal for the position 
      posted by '${client_name}'. Tailor your response to address 
      the specific '${job_title}' and '${problem}' requirements outlined by the client. 
      Highlight your expertise in '${job_title}', emphasizing your ability to meet deadlines, 
      conduct in-depth research, and adapt your writing style to align with the client's needs. 
      Include a brief mention of your portfolio or relevant samples to showcase your work. 
      Add '${freelance_name}' at the end after Best regards. Do not include [Your Full Name] or something similar and also subject is not needed.`;

      // Make an asynchronous call to the server-side script
      const response = await jQuery.ajax({
        type: 'POST',
        url: apiUrl,
        data: {
          action: 'bitcx_aipb_ai_response',
          nonce: nonce,
          prompt: prompt,
        },
      });

      // Parse and handle the response
      try {
        const trimmedResponse = response.slice(0, -1);
        const outerResponse = JSON.parse(trimmedResponse);
        if (outerResponse.response) {
          const responseData = JSON.parse(outerResponse.response);
  
          if (responseData.error) {
            ai_response.show();
            ai_response.text(responseData.error.message);
          } else {
            const solution = responseData.choices[0].message.content.trim();
            // Update the solution field with the generated answer
            $('#bitcx_aipb_solution').val(solution);
          }
        } else {
          console.error('Invalid response format: Missing "response" property.');
        }
      } catch (error) {
        console.error('Error parsing JSON response:', error.message);
        // Handle the error
      }
    } catch (err) {
      ai_response.show();
      ai_response.text('An error occurred while processing the request.');
    } finally {
      // Hide the loading spinner after the request is completed
      loadingSpinner.hide();
    }
  
    function showError(fieldName) {
      ai_response.show();
      ai_response.text(`Please enter the ${fieldName} before getting a solution.`);
    }
  });
  
})
.fail(function(error) {
  console.error('Error obtaining nonce:', error);
});

  /**
   * Expand solution textarea height 
   */
$('#bitcx_aipb_solution').on('focus', function() {
  $(this).css('height', 'auto').css('height', (this.scrollHeight - 22) + 'px');
});

$('#bitcx_aipb_solution').on('input', function() {
  $(this).css('height', 'auto').css('height', (this.scrollHeight - 22) + 'px');
});

$('#bitcx_aipb_solution').on('blur', function() {
  $(this).css('height', '');
});

  /**
   * Expand Problem textarea height 
   */
  $('#bitcx_aipb_problem_desc').on('focus', function() {
    $(this).css('height', 'auto').css('height', (this.scrollHeight - 22) + 'px');
  });
  
  $('#bitcx_aipb_problem_desc').on('input', function() {
    $(this).css('height', 'auto').css('height', (this.scrollHeight - 22) + 'px');
  });
  
  $('#bitcx_aipb_problem_desc').on('blur', function() {
    $(this).css('height', '');
  });

  /**
   * Get Proposal
   */

  $("#bitcx_aipb_get_proposal").click(function (event) {
    event.preventDefault();

    const clientName = jQuery("#bitcx_aipb_client_name").val();
    const porblemDesc = jQuery("#bitcx_aipb_problem_desc").val();
    const solution = jQuery("#bitcx_aipb_solution").val();
    const portfolio_items = jQuery("input[name='bitcx_aipb_portfolioChoice']:checked");
    const testimonial_items = jQuery("input[name='bitcx_aipb_testiChoice']:checked");
    const questions = jQuery("#bitcx_aipb_problem_question").val();
    const cta_item = jQuery("input[name='bitcx_aipb_ctaChoice']:checked");

    if (clientName != "" && porblemDesc != "" && solution != "") {
      let portfolios = [];
      let testimonials = [];
      let ctas = [];
      let portfolio_content = "";
      let testimonial_content = "";
      let cta_content = "";
      let questions_content = "";
      let finalOutput = "";

      portfolio_items.each(function () {
        portfolios.push([
          $(this).attr("data-title"),
          $(this).attr("data-url"),
          $(this).attr("data-desc"),
          $(this).attr("data-img"),
        ]);
      });

      testimonial_items.each(function () {
        testimonials.push([
          $(this).attr("data-title"),
          $(this).attr("data-desc"),
        ]);
      });

      cta_item.each(function () {
        ctas.push([$(this).attr("data-title"), $(this).attr("data-desc")]);
      });

      if (portfolios.length != 0) {
          portfolio_content = `
            <h4>Portfolio Link: </h4>
            <ul>
              ${Object.keys(portfolios)
                .map(function (key) {
                  return (
                    "<li>" +
                    portfolios[key][0] +
                    " : " +
                    portfolios[key][1] +
                    "</li>"
                  );
                })
                .join("")}
            </ul>
          `;
        // console.log(portfolios);
        let encodedArray = JSON.stringify(portfolios);
        jQuery("#bitcx_aipb_dwnld_brochure").attr("data-prtfolio", encodedArray);
      }

      if (testimonials.length != 0) {
        testimonial_content = `
          <p><strong>Here is what our clients say:</strong></p>
          <div>
            ${Object.keys(testimonials)
              .map(function (key) {
                return (
                    "<div>" +
                    
                  "<p>" + 
                    testimonials[key][1] +
                  "</p> <span> " +
                  testimonials[key][0] +
                  "</span>" + "</div>"
                );
              })
              .join("")}
          </div>
        `;
      }

      if (questions != "") {
        let questionStr = questions.replace(/(?:\r\n|\r|\n)/g, "<br>");
        questions_content = `
                <p><strong>Could you please confirm below information? </strong></p>
                <div>${questionStr}</div>
              `;
      }

      if (ctas.length != 0) {
        cta_content = `
                <div>
                  ${Object.keys(ctas)
                    .map(function (key) {
                      return (
                        "<p>" + ctas[key][1] + "</p><p>" + ctas[key][0] + "</p>"
                      );
                    })
                    .join("")}
                </div>
              `;
      }

      finalOutput = `
          <pre>${solution} </pre>
      `;

      if (portfolio_content != "") {
        finalOutput += portfolio_content;
      }

      if (testimonial_content != "") {
        finalOutput += testimonial_content;
      }

      if (questions_content != "") {
        finalOutput += questions_content;
      }

      if (cta_content != "") {
        finalOutput += cta_content;
      }

      if (portfolios.length != 0) {
        // console.log(portfolios);
        // downloadPDF(portfolios);
        jQuery("#bitcx_aipb_dwnld_brochure").removeClass("bitcx_aipb_pr_d_none");
        // document.querySelector('#pr_output').classList.remove('pr_d_none')
      }
      // console.log( " this is this" + finalOutput);
      if (finalOutput != "") {
        jQuery("body").addClass("overlayed");
        document.querySelector("#bitcx_aipb_pr_result").classList.add('bitcx_aipb_pr_d_none');
        document.querySelector('#bitcx_aipb_pr_output').classList.remove('bitcx_aipb_pr_d_none');
        document.querySelector(".bitcx_aipb_popup_content").innerHTML = finalOutput;
      }
    } else {
      document.querySelector("#bitcx_aipb_pr_result p").innerText = "Please Fill All the Fields";
      document.querySelector("#bitcx_aipb_pr_result").classList.remove('bitcx_aipb_pr_d_none');
    }
  });

  /**
   * Function: Download PDF
   */
  
  function downloadPDF(sourceArray) {
    let pdf = new jsPDF("p", "pt", "letter", "mm", [400, 480]);

    let specialElementHandlers = {
      "#bypassme": function (element, renderer) {
        return true;
      },
    };

    let margins = {
      top: 80,
      bottom: 60,
      left: 40,
      width: 522,
    };

    let index = 0;
    for (let i = 0; i < sourceArray.length; i++) {
      let recordTitle = sourceArray[i][0];
      let recordURL = sourceArray[i][1];
      let recordDescription = sourceArray[i][2];
      let recordImageURL = sourceArray[i][3];

      let htmlContent = `
              <div class="bitcraftx_aipb_single-portfolio-item bitcraftx_aipb_pagebreak">
                <h5>${recordTitle}</h5>
                <a href="${recordURL}" target="_blank">${recordURL}</a>
                <p>${recordDescription}</p>
                <img src="${recordImageURL}" width="500" height="350" />
              </div>
            `;

      pdf.fromHTML(
        htmlContent,
        margins.left,
        margins.top,
        {
          width: margins.width,
          elementHandlers: specialElementHandlers,
        },
        function (dispose) {
          if (sourceArray.length > 1 && index !== sourceArray.length - 1) {
            index++;
            pdf.addPage();
          } else {
            pdf.save("Proposal.pdf");
          }
        },
        margins
      );
    }
  }


  /**
   * Download PDF on Button Click
  */

  jQuery("body").on("click", "#bitcx_aipb_dwnld_brochure", function () {
    const dataArrayAsString = $(this).attr('data-prtfolio');
    const retrievedArray = JSON.parse(dataArrayAsString);
    // console.log(retrievedArray);
    downloadPDF(retrievedArray);
  });

  /**
   * Display Portfolio Items w.r.t Category
  */
  $("#bitcx_aipb_portfolio_cats").change(function (event) {
    // Listen for the change event on the select element
    var selectedCategory = $(this).val();
    if (selectedCategory === "") {
      // If "All Categories" is selected, show all items
      $("div[data-cat]").show();
    } else {
      // Otherwise, hide all items and show the selected category item
      $("div[data-cat]").hide();
      $('div[data-cat*="' + selectedCategory + '"]').show();
    }
    showcontroller();
  });

  function showcontroller(){
    var swiperContainer = document.querySelector('.bitcx_swiper');
    var slides = swiperContainer.querySelectorAll('.swiper-slide');
    var visibleSlides = 0;
    slides.forEach(function (slide) {
      var computedStyle = window.getComputedStyle(slide);
      if (computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden') {
        visibleSlides++;
      }
    });
    console.log(visibleSlides);
    if(visibleSlides<=3){
      $(".swiper-button-next").hide();
      $(".swiper-button-prev").hide();
      
    } else {
      $(".swiper-button-next").show();
      $(".swiper-button-prev").show();
    }
  }
  showcontroller();

  /**
   * Display Portfolio Items w.r.t Category
  */
  var swiper = new Swiper(".bitcx_swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    freeMode: true,
    navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
    loop:true,
    // Responsive breakpoints
    breakpoints: {
      480: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }
  });

  /**
   * Output
  */
  document.querySelector('.bitcx_aipb_cross_icon').addEventListener('click' , function(){
    jQuery("body").removeClass("overlayed");
    document.querySelector('#bitcx_aipb_pr_output').classList.add('bitcx_aipb_pr_d_none');
    document.getElementById("bitcx_aipb_copy_button").innerText = "Click To Copy";
  });

  /**
   * Click to Copy Functionality
  */
  
  document.getElementById("bitcx_aipb_copy_button").addEventListener("click", function() {
    // Get the text content from the div element
    var textToCopy = document.getElementById("bitcx_aipb_popup_content").innerText;
  
    // Create a temporary textarea to copy the text to clipboard
    var tempTextArea = document.createElement("textarea");
    tempTextArea.value = textToCopy;
    document.body.appendChild(tempTextArea);
  
    // Select the text in the temporary textarea
    tempTextArea.select();
    tempTextArea.setSelectionRange(0, 99999); // For mobile devices
  
    // Copy the selected text to clipboard
    document.execCommand("copy");
  
    // Remove the temporary textarea
    document.body.removeChild(tempTextArea);
  
    // Show a message to the user indicating successful copy (optional)
    // alert("Text copied to clipboard!");
    document.getElementById("bitcx_aipb_copy_button").innerText = "Copied";
  });

 

})(jQuery);

